









import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
import Appconst from '../../lib/appconst';
@Component
export default class DownloadList extends AbpBase  {
	@Prop({type:Array}) items:Array<any>;
	initData:any = {
		fileUrl: Appconst.fileUrl
	}
}
